function showLayout(){
    const layout = document.querySelector('.layout--popup');
    if (layout.classList.contains('layout--closed')) layout.classList.remove('layout--closed');
}

function closeLayout(){
    const layout = document.querySelector('.layout--popup');
    if (!layout.classList.contains('layout--closed')) layout.classList.add('layout--closed');
}

function showPopup(){
    const popup = document.querySelector('.our-cars__popup');
    if(!popup.classList.contains('.our-cars__popup--opened')) {
        popup.classList.remove('our-cars__popup--closed');
        popup.classList.add('our-cars__popup--opened');
    }
}

function closePopup(){
    const popup = document.querySelector('.our-cars__popup');
    if(popup.classList.contains('our-cars__popup--opened')) {
        popup.classList.remove('our-cars__popup--opened')
        popup.classList.add('our-cars__popup--closed');
    }
}


function addEventListenerToLayout(){
    const layout = document.querySelector('.layout--popup');
    if(layout){
        layout.addEventListener('click', () =>{
            closePopup();
            closeLayout();
        })
    }
}

function addEventListenerToPopupCloseBtn(){
    const closeBtn = document.querySelector('.our-cars__popup-close');
    closeBtn.addEventListener('click', () =>{
        closePopup();
        closeLayout();
    })

}

function initPopup(){
    if(document.querySelector('.our-cars')){
        addEventListenerToCars();
        addEventListenerToLayout();
    }
}

function fetchDataForPopup(id){
    let sendId = id;
    let post_id = document.querySelector('main').dataset.id;

    $.ajax({
        type : "POST", 
        url : load_more_news_params.ajaxurl,
        data : {
            action: "get_data_for_popup",
            id : +sendId,
            post_id: +post_id,
        },
        success: function(response) {
            let popupContainer = document.querySelector('.our-cars__popup');
            popupContainer.innerHTML = response;
            showPopup();
            showLayout();
            addEventListenerToPopupCloseBtn();
        }
    })
}

function addEventListenerToCars(){
    const cars = document.querySelectorAll('.our-cars__img');
    if(cars){
        cars.forEach(car => car.addEventListener('click', (event) =>{
            fetchDataForPopup(+event.currentTarget.dataset.imgId);
        }))
    }
}
addEventListenerToLayout();
addEventListenerToCars();

function showVideoPopup(){
    const popup = document.querySelector('.video__popup');
    const layout = document.querySelector('.layout--video');
    if(!popup.classList.contains('video__popup--opened')) {
        popup.classList.add('video__popup--opened');
        popup.classList.remove('video__popup--closed');
        layout.classList.remove('layout--closed')
        layout.classList.add('layout--opened')
    } else {
        popup.classList.remove('video__popup--opened');
        popup.classList.add('video__popup--closed');
        layout.classList.add('layout--closed')
        layout.classList.remove('layout--opened')
    }
}

function showVideo(){
    const videoBtn = document.querySelector('.btn-video');
    const layout = document.querySelector('.layout--video');
    if(videoBtn){

        videoBtn.addEventListener('click', (event)=>{
            event.preventDefault();
            showVideoPopup();
        })
        layout.addEventListener('click', () =>{
            showVideoPopup();
        })
    }
}

showVideo();